import React, { useState , useEffect} from "react";
import axios from "axios";

const TableFour5 = props => {
  const API = props.API;
  const [XP, setXP] = useState([0, 0, 0]);
  const [YP, setYP] = useState([0, 0, 0]);
  const [ZP, setZP] = useState([0, 0, 0]);
  const [NP, setNP] = useState([0, 0, 0]);

  const [editable, setEditable] = useState(false);

  const submitForm = data => {
    var settings = {
      url: API + "/sectionfourfive-create",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        xp: data.xp,
        yp: data.yp,
        zp: data.zp,
        np: data.np,
        xyz: data.xyz,
        pi: data.pi,
        avgapip: data.avgapip
      }
    };

    axios(settings)
      .then(res => {
        console.log("Database Stored");
        console.log(res.data);
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    var settings = {
      url: API + "/sectionfourfive-get",
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    };

    axios(settings)
      .then(res => {
        let xp = res.data.xp;
        let yp = res.data.yp;
        let zp = res.data.zp;
        let np = res.data.n;
        xp.length === 0 ? setXP([0, 0, 0]) : setXP(xp);
        yp.length === 0 ? setYP([0, 0, 0]) : setYP(yp);
        zp.length === 0 ? setZP([0, 0, 0]) : setZP(zp);
        np.length === 0 ? setNP([0, 0, 0]) : setNP(np);
      })
      .catch(err => {
        console.log(err);
      });
  }, []);


  const changeData = (type, val, index, previousData) => {
    val = Number(val);

    switch (type) {
      case "XP":
        if (index === 0) setXP([val, previousData[1], previousData[2]]);
        if (index === 1) setXP([previousData[0], val, previousData[2]]);
        if (index === 2) setXP([previousData[0], previousData[1], val]);
        break;
      case "YP":
        if (index === 0) setYP([val, previousData[1], previousData[2]]);
        if (index === 1) setYP([previousData[0], val, previousData[2]]);
        if (index === 2) setYP([previousData[0], previousData[1], val]);
        break;
      case "ZP":
        if (index === 0) setZP([val, previousData[1], previousData[2]]);
        if (index === 1) setZP([previousData[0], val, previousData[2]]);
        if (index === 2) setZP([previousData[0], previousData[1], val]);
        break;
      case "NP":
        if (index === 0) setNP([val, previousData[1], previousData[2]]);
        if (index === 1) setNP([previousData[0], val, previousData[2]]);
        if (index === 2) setNP([previousData[0], previousData[1], val]);
        break;
      default:
        console.log("Default");
    }
  };

  return (
    <div>
      <h2>4.5. Placement, Higher Studies and Entrepreneurship (40)</h2>
      <p>Assessment Points = 40 × average placement</p>
      <table border="1" cellPadding="10" width="80%">
        <tbody>
          {/* Heading */}
          <tr>
            <th>Academic Performance</th>
            <th>
              CAYm1 <br /> (2016-2017)
            </th>
            <th>
              CAYm2 <br /> (2015-2016)
            </th>
            <th>
              CAYm3 <br /> (2014-2015)
            </th>
          </tr>

          {/* N */}
          <tr>
            <td>Total No. of Final Year Students (N)</td>
            {NP.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("NP", e.target.value, index, [
                          NP[0],
                          NP[1],
                          NP[2]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
          </tr>

          {/* XP */}
          <tr>
            <td>
              No. of students placed in companies or Government Sector (x)
            </td>
            {XP.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("XP", e.target.value, index, [
                          XP[0],
                          XP[1],
                          XP[2]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
          </tr>

          {/* YP */}
          <tr>
            <td>
              No. of students admitted to higher studies with valid qualifying
              scores (GATE or equivalent State or National Level Tests, GRE,
              IELTS, GMAT etc.) (y){" "}
            </td>
            {YP.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("YP", e.target.value, index, [
                          YP[0],
                          YP[1],
                          YP[2]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
          </tr>

          {/* ZP */}
          <tr>
            <td>
              No. of students turned entrepreneur in engineering/technology (z)
            </td>
            {ZP.map((d, index) => {
              if (editable)
                return (
                  <td key={index}>
                    <input
                      type="number"
                      value={d}
                      onChange={e =>
                        changeData("ZP", e.target.value, index, [
                          ZP[0],
                          ZP[1],
                          ZP[2]
                        ])
                      }
                    />
                  </td>
                );
              else return <td key={index}>{d}</td>;
            })}
          </tr>

          {/* XYZ */}
          <tr>
            <td>x + y + z = </td>
            <td>{XP[0] + YP[0] + ZP[0]}</td>
            <td>{XP[1] + YP[1] + ZP[1]}</td>
            <td>{XP[2] + YP[2] + ZP[2]}</td>
          </tr>

          {/* PI   */}
          <tr>
            <td>Placement Index : (x + y + z )/N </td>
            <td>{Math.trunc((XP[0] + YP[0] + ZP[0]) / NP[0]).toString()}</td>
            <td>{Math.trunc((XP[1] + YP[1] + ZP[1]) / NP[1]).toString()}</td>
            <td>{Math.trunc((XP[2] + YP[2] + ZP[2]) / NP[2]).toString()}</td>
          </tr>

          {/* AVGAPI */}
          <tr>
            <td>Average API = (AP1 + AP2 + AP3)/3</td>
            <td colSpan="3">
              {Math.trunc(
                (Math.trunc((XP[0] + YP[0] + ZP[0]) / NP[0]) +
                  Math.trunc((XP[1] + YP[1] + ZP[1]) / NP[1]) +
                  Math.trunc((XP[2] + YP[2] + ZP[2]) / NP[2])) /
                  3
              ).toString()}
            </td>
          </tr>
        </tbody>
      </table>
      {editable ? null : (
        <button onClick={() => setEditable(true)}>Edit</button>
      )}
      &nbsp;
      <button
        onClick={() => {
          setEditable(false);

          var data = {
            xp : XP,
            yp : YP,
            zp : ZP,
            np : NP,
            xyz : [
              XP[0] + YP[0] + ZP[0],
              XP[1] + YP[1] + ZP[1],
              XP[2] + YP[2] + ZP[2]
            ],
            pi: [
              Math.trunc((XP[0] + YP[0] + ZP[0]) / NP[0]),
              Math.trunc((XP[1] + YP[1] + ZP[1]) / NP[1]),
              Math.trunc((XP[2] + YP[2] + ZP[2]) / NP[2])
            ],
            avgapip: [Math.trunc(
              (Math.trunc((XP[0] + YP[0] + ZP[0]) / NP[0]) +
                Math.trunc((XP[1] + YP[1] + ZP[1]) / NP[1]) +
                Math.trunc((XP[2] + YP[2] + ZP[2]) / NP[2])) /
                3
            )]
          };
          console.log(data);
          submitForm(data);
        }}
      >
        Submit
      </button>
    </div>
  );
};

export default TableFour5;
